
import Vue from 'vue';

export const state = Vue.observable({
    objPrams: {},
    reSetData: false,
    listClear: false,
});

export const mutations = {
    add (payload) {
        state.objPrams = payload;
    },
    retData (payload) {
        state.reSetData = payload;
    },
    clearOlist (payload) {
        state.listClear = payload;
    }
};
